"use client"

import {
    Box,
    Container,
    Typography
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import '../../assets/styles/scss/_userDeal.scss'
import DealCard from "./DealCard"
import InfoIcon from '@mui/icons-material/Info';
import ScrollableChips from "./ScrollableChips";
import DynoLoader from "../DynoLoader";
import RegisterationForm from "./RegisterationForm";

export default function DealsView({
                                      resultType,
                                      inputValue,
                                      deals,
                                      user,
                                      deleteDeal,
                                      categories,
                                      selectedNav,
                                      setSelectedNav,
                                      setQuestionaireModal,
                                      updateRecommendation,
                                      totalActivePromotions,
                                      totalCount,
                                      isLoading,
                                      onViewMore,
                                      isDealLoading,
                                      hasMoreDeals,
                                      questions,
                                      questionaireModal
                                  }) {
    console.log("IsDealLoading", isDealLoading, "Deals", deals?.length)

    return (
      <Container sx={{ width: "100%", maxWidth: "100%!important" }}>
        <div className="deals-header">
          {resultType !== "search" ? "Deals for You" : `Search Results for "${inputValue}"`}
        </div>

        {resultType !== "search" && (
          <ScrollableChips
            categories={categories}
            selectedNav={selectedNav}
            setSelectedNav={setSelectedNav}
          />
        )}

        {!!totalActivePromotions && !isLoading && (
          <div
            className="deals-info-alert d-flex align-items-center"
            style={{ fontFamily: "inherit" }}
          >
            <InfoIcon className="deals-info-alert__icon" />
            <div>
              We picked {totalCount.toLocaleString()} promotions curated only
              for you out of {totalActivePromotions.toLocaleString()} total
              active promotions.
            </div>
          </div>
        )}

        {!isLoading && deals && !deals.length && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              mt: 15,
            }}
          >
            <Typography variant="h3" color="textSecondary">
              Deals not found
            </Typography>
          </Box>
        )}

        <Grid container spacing={2}>
          {deals && deals.map((deal, index) => (
            <DealCard
              key={index}
              deal={deal}
              categories={categories}
              setQuestionaireModal={setQuestionaireModal}
              user={user}
              updateRecommendation={updateRecommendation}
              deleteDeal={deleteDeal}
            />
          ))}
        </Grid>

        {isDealLoading ? (
          <DynoLoader
            height="300px"
            width="100%"
            justifyContent="center"
            alignItems="center"
          />
        ) : (
          !!hasMoreDeals ? (
            <div className="view-more-container">
              <button
                onClick={onViewMore}
                disabled={isDealLoading}
                className="btn btn-primary view-more-button"
              >
                {isDealLoading ? "Loading..." : "View More Deals"}
              </button>
            </div>
          ) : (!user && <RegisterationForm
                questions={questions}
                hasDeals={deals && !!deals.length}
              />)
        )}
      </Container>
    );
}
